import "amfe-flexible";
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import {
  /* eslint-disable no-unused-vars */
  Style,
  Button,
  CheckboxGroup,
  Radio,
  // Input,
  // Textarea,
  // Select,
  Switch,
  // Rate,
  // Validator,
  // Loading,
  // Tip,
  Popup,
  Toast,
  Picker,
  CascadePicker,
  // TimePicker,
  DatePicker,
  Dialog,
  // ActionSheet,
  Scroll,
  // Slide,
  // IndexList,
  Swipe,
  createAPI,
  // Upload
} from "cube-ui";
import App from "./App";
import router from "./router";
import fastclick from "fastclick";
import VueLazyload from "vue-lazyload";
import storage from "good-storage";
import { Hub, ToastCeate } from "common/js/hub";
import "common/js/axiosset";
import "common/stylus/index.styl";
import "common/fonts/iconfont.css";
import { isWechatClient, getQueryString } from "common/js/util";
import { getRedirectUrl, weiChatLogin, setStorage } from "api/user";
import { resCode, rootFile } from "api/config";
import globalComponents from "@/components/global-components.js";
import * as echarts from "echarts";
import VantGreen from "vant-green";
import "vant-green/lib/index.css";
import "@vant/touch-emulator";
Vue.use(VantGreen);
Vue.prototype.$echarts = echarts;
Vue.use(globalComponents);
Vue.use(Button);
Vue.use(CheckboxGroup);
Vue.use(Radio);
// Vue.use(Input)
// Vue.use(Textarea)
// Vue.use(Select)
Vue.use(Switch);
// Vue.use(Rate)
// Vue.use(Validator)
// Vue.use(Loading)
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(CascadePicker);
// Vue.use(TimePicker)
Vue.use(DatePicker);
Vue.use(Dialog);
// Vue.use(ActionSheet)
Vue.use(Scroll);
// Vue.use(Slide)
// Vue.use(IndexList)
Vue.use(Swipe);
// Vue.use(Upload)
// Vue.use(createAPI(Vue, Toast, ['click'], false))
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-app", "wx-open-launch-weapp"];
Vue.use(VueLazyload, {
  loading: require("@/assets/avatar.png"),
  error: require("@/assets/avatar.png"),
  attempt: 3,
});
fastclick.attach(document.body);

Hub.commonUrl = location.href;
Hub.mainToast = ToastCeate("", "loading", 0);
Hub.user = storage.get("user") || "";

Vue.prototype.Hub = Hub;
/* 弹出框封装 开始 */
Vue.prototype.ceateToast = function (title, icon, time) {
  Hub.mainToast.remove();
  Hub.mainToast = ToastCeate(title, icon, time);
};

Vue.prototype.toastShow = function () {
  Hub.mainToast.show();
  Hub.isToastShow = true;
};

Vue.prototype.toastHide = function () {
  Hub.mainToast.hide();
  Hub.isToastShow = false;
  Hub.mainToast.remove();
};

Vue.prototype.noLoadingShow = function () {
  Hub.isToastShow = true;
};
/* 弹出框封装 结束 */

router.beforeEach((to, form, next) => {
  document.title = to.meta.title || "新干线观察";
  next();
});
Vue.prototype.$isNullOrUndefined = function (value) {
  return (
    value == null ||
    value === undefined ||
    value === "" ||
    value === "undefined"
  );
};
// router.afterEach((to, from) => {
//   Hub.mainToast.hide()
//   Hub.isToastShow = false
//   Hub.mainToast.remove()
// })

Vue.directive("focus", {
  inserted: function (el) {
    el.focus();
  },
});
Vue.filter("dateFormat", function (value = "0") {
  let arr = value.split("-");
  return arr[1] + "." + arr[2];
});
Vue.filter("moneyFormat", function (value = "0") {
  value = parseFloat(value);
  if (value == 0) {
    return "0.00";
  }
  if (!value) {
    return "";
  }
  return value.toFixed(2);
});

Vue.filter("moneyFormat1", function (value = "0") {
  let result = value.toString().indexOf(".");
  value = parseFloat(value);
  if (result != -1) {
    return value.toFixed(2);
  }
  if (!value) {
    return "";
  }
  return value;
});

Vue.filter("areaFilter", function (value) {
  if (!value) {
    return "";
  }
  const sArea = value.split("-");
  if (sArea.length < 3) {
    return value;
  }
  if (sArea[0] == sArea[1]) {
    return `${sArea[1]}${sArea[2]}`;
  } else {
    return `${sArea[0]}${sArea[1]}${sArea[2]}`;
  }
});

Vue.prototype.getRootPath = function () {
  let strFullPath = window.document.location.href;
  let strPath = window.document.location.pathname;
  let pos = strFullPath.indexOf(strPath);
  let prePath = strFullPath.substring(0, pos);
  let postPath = strPath.substring(0, strPath.substr(1).indexOf("/") + 1);
  return prePath + postPath;
};

Vue.prototype.$strDateToTime = function (value) {
  // 用/替换日期中的-是为了解决Safari的兼容
  return new Date(value.replace(/-/g, "/")).getTime();
};

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js